<div class="confirmationContainer batch-submission">
  <img class="confirmationContainer__headerIcon" src="/assets/svg/icons/circle_check.svg" />
  <div class="confirmationContainer__infoGreen">
    <h2>Registration Complete!</h2>
  </div>

  <h3 class="confirmationContainer__reasonTitle">
    Congratulations, You have successfully setup your business account.
  </h3>

  <div class="confirmationContainer__navigationButtons">
    <button class="cmn-draft-btn btnSpacing" type="button" (click)="navigateToAdminPanel()">
      <span class="material-icons btn-arw">keyboard_arrow_left</span>Admin Panel
    </button>
    <button class="cmn-blue-btn" type="button" (click)="navigateToHomePage()">
      Go To Home Page <span class="material-icons btn-arw">keyboard_arrow_right</span>
    </button>
  </div>
</div>
